const Logo = require('assets/images/logo.png')

export default [
  {
    id: 'logo',
    src: Logo
  }
]
